import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  keyLoading,
  resetPricingPackagesByUserType,
  selectLoading,
  selectPricingPackagesByUserType,
} from './store/slice'
import { getPricingPackagesByUserTypeThunk } from './store/thunk'

const usePricingPackagesByUserType = (disableCallApi) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(
    selectLoading(keyLoading.PRICING_PACKAGES_BY_USER_TYPE),
  )
  const pricingPackages = useSelector(selectPricingPackagesByUserType)

  useEffect(() => {
    if (!disableCallApi && locale) {
      dispatch(getPricingPackagesByUserTypeThunk())
    }
  }, [locale])

  useEffect(() => {
    return () => dispatch(resetPricingPackagesByUserType())
  }, [])

  return {
    loading,
    pricingPackages,
  }
}

export default usePricingPackagesByUserType
